import type { DirectorReasoningEffort } from "@actale/contracts";

export const CUSTOM_DIRECTOR_MODEL = "__custom__";

export interface DirectorModelPreset {
  modelName: string;
  label: string;
  description: string;
  reasoningEffort: DirectorReasoningEffort | null;
  timeoutMs: number;
  inputCostPerMillionUsd: number;
  outputCostPerMillionUsd: number;
}

export const DIRECTOR_MODEL_PRESETS: readonly DirectorModelPreset[] = [
  {
    modelName: "gpt-5.6-sol",
    label: "GPT-5.6 Sol",
    description: "",
    reasoningEffort: "high",
    timeoutMs: 60_000,
    inputCostPerMillionUsd: 4,
    outputCostPerMillionUsd: 20,
  },
  {
    modelName: "gpt-4.1-mini",
    label: "GPT-4.1 Mini",
    description: "低延迟 · 非推理模型",
    reasoningEffort: null,
    timeoutMs: 20_000,
    inputCostPerMillionUsd: 0.4,
    outputCostPerMillionUsd: 1.6,
  },
] as const;

export function directorModelPreset(modelName: string): DirectorModelPreset | null {
  return DIRECTOR_MODEL_PRESETS.find((preset) => preset.modelName === modelName) ?? null;
}
